import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import T from 'i18n-react';
import cx from 'classnames';
import { Button, Dropdown, DropdownMenu } from '@adsk/bim360-matrix-react-components';
import { noop as lodashNoop } from 'lodash';


class ProjectViewExport extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      isExportButtonOpen: false,
    };
  }

  render() {
    const { disabled, exportOptions, isFetchReportLoading, exportingText } = this.props;
    const isSingleExportButton = exportOptions.length === 1;

    const iconClassName = cx('ProjectViewExport__export-button-icon', {
      'ProjectViewExport__export-button-icon--open': this.state.isExportButtonOpen,
    });

    const exportButtonClassName = cx('ProjectViewExport__export-button', {
      'ProjectViewExport__export-button--disabled': disabled,
      'ProjectViewExport__export-button--dropdown': !isSingleExportButton,
    });

    return (
      <div>
        {isSingleExportButton
          ? <Button onClick={exportOptions[0].handleOnClick} disabled={disabled}
            className={exportButtonClassName} data-testid="ProjectViewExport__exportButton"
          >
            <span className="ProjectViewExport__export-text">{isFetchReportLoading ? exportingText : exportOptions[0].label}</span>
          </Button>
          : <Dropdown disabled={disabled}
            onToggleMenu={() => this.setState({ isExportButtonOpen: !this.state.isExportButtonOpen })}
            onSelect={lodashNoop} className="ProjectViewExport__export-dropdown"
          >
            <Button disabled={disabled} className={exportButtonClassName} data-testid="ProjectViewExport__exportButton">
              <span className="ProjectViewExport__export-text">{isFetchReportLoading ? exportingText : T.translate('export.export')}</span>
              <span className={iconClassName} />
            </Button>
            <DropdownMenu className="ProjectViewExport__export-dropdown-list">
              {exportOptions.map((option, index) => <li key={index}>
                <div className="ProjectViewExport__export-item" data-testid="ProjectViewExport__exportListItem" onClick={option.handleOnClick}>{option.label}</div>
              </li>)}
            </DropdownMenu>
          </Dropdown>
        }
      </div>
    );
  }
}

ProjectViewExport.displayName = 'ProjectViewExport';

ProjectViewExport.propTypes = {
  disabled: PropTypes.bool,
  isFetchReportLoading: PropTypes.bool,
  exportingText: PropTypes.string,
  exportOptions: PropTypes.array.isRequired,
};

export default ProjectViewExport;
